import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/main/Footer";

const LandingPageLayout = () => {
  return (
    <section>
      <div>
        <div>
          <main>
            <Header />
            <Outlet />
          </main>
        </div>
        <section className="relative w-full py-16 md:py-24 overflow-hidden bg-white">
          <Footer />
        </section>
      </div>
    </section>
  );
};

export default LandingPageLayout;
